import React, { Component } from 'react';
import isContractInitialized from '../../utils/ContractInitializationState';
import LoadingAnimation from '../Components/LoadingAnimation';
import { TX_ERROR_GIVE_ETHER, TX_GIVE_ETHER } from '../../utils/TransactionTypes';
import {
  addTransactionInProgress,
  transactionErrorHandler,
  transactionReceiptHandler
} from '../../utils/TransactionStateHelper';

class GiveEther extends Component {
  constructor (props) {
    super(props);

    this.state = {
      ether: '',
      contractLoaded: false
    };

    this.storageUnsubscribe = null;
  }

  componentDidMount () {
    this.isContractLoaded();
    this.storageUnsubscribe = Storage.subscribe(() => this.isContractLoaded());
  }

  isContractLoaded () {
    isContractInitialized() && !this.state.contractLoaded && this.init();
  }

  componentWillUnmount () {
    this.storageUnsubscribeHandler();
  }

  storageUnsubscribeHandler () {
    this.storageUnsubscribe && this.storageUnsubscribe();
  }

  init () {
    this.storageUnsubscribeHandler();
    this.setState({
      contractLoaded: true
    });
  }

  handleEtherChange = (event) => {
    this.setState({
      ether: +event.target.value || ''
    });
  };

  handleBuying = (event) => {
    // We don't want normal page submit
    event.preventDefault();

    if (this.state.ether <= 0) {
      window.notifications.showError('Ether must be over 0.');

      return;
    }

    window.contract
      .methods
      .sendEtherToContract()
      .send({
        from: Storage.getState().account.currentAccount,
        value: window.web3Service.utils.toWei(this.state.ether.toString()),
        gasPrice: 0
      })
      .on('transactionHash', (hash) => addTransactionInProgress(hash, TX_GIVE_ETHER, TX_ERROR_GIVE_ETHER))
      .on('receipt', (receipt) => transactionReceiptHandler(receipt, () => {
        this.setState({
          ether: ''
        });

        window.notifications.showSuccess('Ether was successfully sent to the contract.');
      }))
      .on('error', (err, receipt) => transactionErrorHandler(err, receipt));
  };

  renderForm () {
    if (!this.state.contractLoaded) {
      return (<LoadingAnimation/>);
    }

    return (
      <form onSubmit={this.handleBuying}>
        <div className="c-form-row">
          <label>Ether</label>
          <input type="number" placeholder="Ether" name="ether" value={this.state.ether}
                 onChange={this.handleEtherChange}/>
        </div>
        <div className="c-form-row">
          <button type="submit">Give Ether</button>
        </div>
      </form>
    );
  }

  render () {
    return (
      <div className="c-component c-give-ether">
        <h2>Give Ether</h2>
        {this.renderForm()}
      </div>
    );
  }
}

export default GiveEther;



// WEBPACK FOOTER //
// ./src/components/EtherPage/GiveEther.js